var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-toast",class:[
    _vm.icon ? 'has-icon' : '',
    _vm.position ]},[_c('md-popup',{attrs:{"hasMask":_vm.hasMask,"maskClosable":false},on:{"hide":_vm.$_onHide},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('div',{staticClass:"md-toast-content"},[(_vm.icon)?_c('md-icon',{attrs:{"name":_vm.icon,"size":"lg"}}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.content)}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aae720e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/vxmobile/components/toast/toast.vue
// module id = null
// module chunks = 